// Text direction of a locale (C313). A right-to-left language (Arabic, Hebrew, Persian, Urdu) mirrors the layout. The layout
// uses logical utilities only (ms-, me-, ps-, pe-, start, end), so the mirror needs no change on any page.

const RIGHT_TO_LEFT = new Set(["ar", "fa", "he", "ur"]);

/** "rtl" for a right-to-left language tag (ar, ar-SA, he-IL), else "ltr". The region and script parts are ignored. */
export function textDirection(locale: string): "ltr" | "rtl" {
  const language = (locale.trim().toLowerCase().split(/[-_]/)[0] ?? "").trim();
  return RIGHT_TO_LEFT.has(language) ? "rtl" : "ltr";
}

/** Sets the document's language and direction for the locale. Called once at boot, after the saved locale is known. */
export function applyDirection(locale: string): void {
  document.documentElement.lang = locale;
  document.documentElement.dir = textDirection(locale);
}
